import { TApplicationState } from '../../types/redux';

export const selectFormPhoneVerificationError = (state: TApplicationState) =>
  state.requestFormV2.errors.phoneVerification;
